
/**
 * Mapping Service
 * Based around Google Maps API. Setup global API access to the Google Maps APIs
 */
export default class MapService {
  constructor() {
    this.geocodeAPI = null

    this.googleMapAPI = null
    this.googleMapLoading = false

    this.promiseWaitingList = []
  }


  /**
   * Load the Google Maps API
   * Lazy Loaded. Will load the first time it's called
   * 
   * @return {Promise} Returns a promise resolved on succesful loading of the Google Maps APIs
   */
  loadGoogleMaps() {
    return new Promise((resolve, reject) => {
      let self = this

      if(this.googleMapAPI)
        return resolve()

      // If loading & waiting, add this promise to waiting list
      if(this.googleMapLoading) {
        this.promiseWaitingList.push({
          resolve: resolve,
          reject: reject
        })
        return
      }

      window.googleMapsAutoCompleteAPILoad = function() {
        self.googleMapAPI = window.google

        self.promiseWaitingList.forEach(promiseInfo => {
          promiseInfo.resolve()
        })
        return resolve()
      }

      // Load Google Maps API
      this.googleMapLoading = true
      let apiKey = process.env.VUE_APP_GOOGLE_MAPS_API_KEY
      var libraries = ['geometry', 'places', 'marker']

      var script = document.createElement('script')
      script.type = 'text/javascript'
      script.src = `https://maps.googleapis.com/maps/api/js?loading=async&callback=googleMapsAutoCompleteAPILoad&key=${apiKey}&libraries=${libraries.join(',')}`

      document.querySelector('head').appendChild(script)

      setTimeout(function() {
        if (!window.google) {
          self.googleMapLoading = false

          self.promiseWaitingList.forEach(promiseInfo => {
            promiseInfo.reject(new Error('Timeout loading Google Maps'))
          })

          reject(new Error('Timeout loading Google Maps'));
        }
      }, 20000)
    })
  }
}